export default __webpack_public_path__ + "static/media/ic_dot.1ac8a96d.svg";